import { CommonModule } from '@angular/common';
import { Component, OnInit } from '@angular/core';
import { FormsModule, NgForm, ReactiveFormsModule } from '@angular/forms';
import { ActivatedRoute, Router } from '@angular/router';
import { HasPermissionDirective } from '../../../utils/has-permission.directive';
import { FullSpinnerService } from '../../../services/full-spinner.service';
import { AppConstants } from '../../../utils/AppConstants';
import { AlertService } from '../../shared/alert/alert.service';
import { Account, ACCOUNT_ROLES } from '../../../models/Account';
import { AccountService } from '../../../services/account.service';
import { Organization } from '../../../models/Organization';
import { OrganizationService } from '../../../services/organization.service';

@Component({
  selector: 'app-account-detail',
  standalone: true,
  imports: [
    CommonModule,
    HasPermissionDirective,
    FormsModule,
    ReactiveFormsModule,
  ],
  templateUrl: './account-detail.component.html',
  styleUrl: './account-detail.component.scss',
})
export class AccountDetailComponent implements OnInit {
  account: Account = { enabled: true };
  organizations: Organization[] = [];
  roles = ACCOUNT_ROLES;

  isEdit: boolean = false;
  detail_title: string = 'Nuovo account';

  constructor(
    private accountService: AccountService,
    private organizationService: OrganizationService,
    private alertService: AlertService,
    private fullSpinnerService: FullSpinnerService,
    private router: Router,
    private activatedRoute: ActivatedRoute
  ) {}

  ngOnInit(): void {
    this.loadOrganizations();

    const accountId = this.activatedRoute.snapshot.paramMap.get('accountId');

    if (accountId) {
      this.isEdit = true;
      this.fullSpinnerService.spinner('');
      this.accountService.get(accountId).subscribe({
        next: (res) => {
          this.account = res;
          this.detail_title = res.username ?? '';
        },
        complete: () => {
          this.fullSpinnerService.spinner(undefined);
        },
        error: () => {
          this.fullSpinnerService.spinner(undefined);
        },
      });
    } else {
      const qpOrganizationId = this.activatedRoute.snapshot.queryParamMap.get('organizationId');
      if (qpOrganizationId) {
        this.account.organizationId = +qpOrganizationId;
      }
    }
  }

  private loadOrganizations(): void {
    this.organizationService.find({ pageSize: 1000, pageNumber: 1 }).subscribe({
      next: (res) => {
        this.organizations = res.items;
      },
      error: () => {},
    });
  }

  onSubmit(form: NgForm): void {
    if (form.valid) {
      this.fullSpinnerService.spinner('');
      this.accountService.save(this.account).subscribe({
        next: () => {
          this.alertService.addErrors(
            AppConstants.titleSuccessMessage,
            [AppConstants.successMessage],
            true
          );
          this.back();
        },
        complete: () => {
          this.fullSpinnerService.spinner(undefined);
        },
        error: () => {
          this.alertService.addErrors(
            AppConstants.titleErrorMessage,
            [AppConstants.errorMessage],
            true
          );
          this.fullSpinnerService.spinner(undefined);
        },
      });
    }
  }

  back(): void {
    this.router.navigate(['accounts']);
  }
}
